import React from 'react';
import { PAGE_CONFIG } from './pageConfig';
// import { PAGE_CONFIG as NEW_PAGE_CONFIG } from './newPageConfig';
import { PAGE_CONFIG_API } from '@home/_config/constant';
import CommonPageRender from '@home/components/CommonPageRender';
import { useParams } from 'umi';
import './index.scss';

const InGameAnalytics = () => {
  const { gameCode } = useParams();

  // 本地测试使用
  // const pageConfig = studioId === 'techland' && gameCode === 'pc_dev_demo' ? NEW_PAGE_CONFIG : PAGE_CONFIG;

  return (
    <CommonPageRender
      key={gameCode}
      reqParams={'/inGameAnalytics'}
      pageConfigInit={PAGE_CONFIG}
      frameType='game'
      api={PAGE_CONFIG_API}
    />
  );
};

export default InGameAnalytics;
